import Link from "next/link";
import { useUser } from "@nju/data-access-portal-user";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Panel, Separator, Text } from "@nju/ui";

export function EmailSentPage() {
  const { email } = useUser();

  return (
    <Panel testId="change-email-success-panel">
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        masz wiadomość
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="envelope-incircle-succes"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <BlockText
        align="center"
        size={{ "@onlyMobile": "s", "@fromTablet": "m" }}
      >
        Sprawdź swoją skrzynkę. Wysłaliśmy Ci maila na:{" "}
        <Text weight={{ "@fromTablet": "bold" }}>{email}</Text>. Otwórz go i
        potwierdź nowy adres.
      </BlockText>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link
          href={portalRoutes.mojeKonto.mojProfil.index.get()}
          passHref={true}
        >
          <A
            className="only-mobile:text-center"
            display={{
              "@onlyMobile": "block",
            }}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
